module.exports = __webpack_public_path__ + "static/img/autumn_pingguoPic.e7e9cf47.png";